
<script>
import PageHeader from "../../components/page-header";
import { faqService, faqCategoryService} from "../../services";
import { success_message, error_message } from "../../Helper/helper";
import config from "../../config";

export default {
  components: { faqService, PageHeader },
  data() {
    const { faq_id} = this.$route.query;
    return {
      faq: [],
      categories: [],
      faq_id : 1,
      config: config,
    };
  },
  init: true,
  mounted() {
    this.getFaqListing();
    this.getAllFaqCategory();
  },
  methods: {
    getFaqListing() {
      faqService.getFaqListing({faq_id : this.faq_id}).then((response) => {
        this.faq = response.data.result;
      });
    },
    deleteById(id) {
      if (confirm("Are you sure you want to delete?")) {
        faqService.deleteFaqById({ id: id }).then((response) => {
          error_message(response.data.message);
          this.getFaqListing();
        });
      }
    },
    getAllFaqCategory() {
      faqCategoryService.getAllFaqCategory()
      .then((response) => {
        if( response.data.result.length > 0){
          this.categories = response.data.result;
          this.faq_id = this.categories[0].id;
        }else{
          this.faq_id = '';
        }
      });
    },
    onTabChanged(faq_id){
      this.faq_id = faq_id;
      this.getFaqListing();
      if(!this.init){
        this.$router.replace({name: 'faq-list', query: {faq_id}})
      }
    }
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div
          class="page-title-box d-flex align-items-center justify-content-between icon-main-page"
        >
          <div class="page-title-left">
            <div class="avatar-xs mr-3">
              <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                <i class="bx bx-question-mark"></i>
              </span>
            </div>
             <h4 class="mb-0 font-size-18">{{ trans.trans('__JSON__.FAQs') }}</h4>
          </div>
          <div class="page-title-right">
            <router-link :to="{name: 'faq-add'}" class="btn btn-success btn-rounded mr-2 add-btn">
              <i class="mdi mdi-plus mr-1"></i>
              {{ trans.get('__JSON__.ADD FAQ') }}
            </router-link>
            <router-link :to="{name: 'faq-add'}" class="btn btn-success btn-rounded mr-2 m-add-btn">
              <i class="mdi mdi-plus"></i>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <div class="checkout-tabs">
      <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-lg-2 w-100">
        <b-tab  :key="category.id" v-for="category in categories" v-on:click="onTabChanged(category.id)" :class="{ 'active': faq_id === category.id }">
          <template v-slot:title>
            <!-- <i class="bx bx-user d-block check-nav-icon mt-4 mb-2"></i> -->
            <img class="vendor-img avatar-xs" :src="config.faq_category+category.icon_img" alt @error="$event.target.src=config.basepath+'no-img.png'"/>
            <p class="font-weight-bold mb-4">{{ category.name }}</p>
          </template>
          <b-card-text>
            <div class="faq-list-card">
              <div class="card">
                <div class="card-body">
                  <div class="tab-pane fade show active">
                    <h4 class="card-title mb-5">{{ trans.get('__JSON__.FAQs') }}</h4>
                    <div v-if="faq.length > 0">
                      <div v-for="customer in faq" :key="customer.id">
                        <!-- <div v-if="customer.type == '0'"> -->
                          <div class="faq-box media">
                            <div class="faq-icon mr-3">
                              <i class="bx bx-help-circle font-size-20 text-success"></i>
                            </div>
                            <div class="media-body">
                              <div class="d-flex align-items-center justify-content-between">
                                <div class="faq-qa">
                                  <h5 class="font-size-15">{{ customer.question }}</h5>
                                  <p class="text-muted">{{ customer.answer }}</p>
                                </div>
                                <div class="d-flex align-items-center faq-btn">
                                  <router-link
                                    :to="{ name: 'faq-edit', params: { id: base64(customer.id) } }"
                                    class="btn btn-success btn-sm btn-rounded"
                                  >{{ trans.get('__JSON__.Edit') }}</router-link>
                                  <button
                                    type="submit"
                                    class="btn btn-danger btn-sm btn-rounded"
                                    @click="deleteById(base64(customer.id))"
                                  >{{ trans.get('__JSON__.Delete') }}</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        <!-- </div> -->
                      </div>
                    </div>
                    <div v-else>
                      <p class="text-center">{{ trans.get('__JSON__.No FAQ Found') }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end card-body -->
            </div>
            <!-- end card -->
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>
    <!-- end row -->
  </div>
</template>